import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { hasPolicyUrl, isExternalPolicyUrl } from "../../utils/policyLinks";

interface PolicyTextLinkProps {
  url?: string;
  label: string;
  sx?: object;
  underline?: "none" | "hover" | "always";
}

const PolicyTextLink: React.FC<PolicyTextLinkProps> = ({
  url,
  label,
  sx,
  underline = "none",
}) => {
  const href = url?.trim() || "";

  if (!hasPolicyUrl(href)) {
    return (
      <Typography component="span" sx={sx}>
        {label}
      </Typography>
    );
  }

  if (isExternalPolicyUrl(href)) {
    return (
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        underline={underline}
        sx={sx}
      >
        {label}
      </Link>
    );
  }

  return (
    <Link component={RouterLink} to={href} underline={underline} sx={sx}>
      {label}
    </Link>
  );
};

export default PolicyTextLink;
